module.exports = __webpack_public_path__ + "media/images/prepaid-bundle-bc655f790c313916078f2dc6940a7909.png";